import axios from 'axios';
import { environment } from 'environments/environment';

export interface DeviceByIDBody {
    SN: string[];
}

export const getDevicesAsync = async () => {
    console.log('getDevicesAsync');
    let y: any[] = [];
    const getDevices = async () => {
        await axios
            .get(`${environment.apiBaseUrl}devices/all`, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                console.log(response);
                // console.log(response.data.data);
                y = response.data.data;
                //return response.data.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getDevices();
    return y;
};

export const getDevicesAsyncConfig = async () => {
    console.log('getDevicesAsyncConfig');
    let y: any[] = [];
    const getDevicesConfig = async () => {
        await axios
            .get(`${environment.apiBaseUrl}devices/allConfig`, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                console.log(response);
                // console.log(response.data.data);
                y = response.data.data;
                //return response.data.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getDevicesConfig();
    return y;
};

export const getDevicesAsyncDTC = async () => {
    console.log('getDevicesAsyncDTC');
    let y: any[] = [];
    const getDevicesDTC = async () => {
        await axios
            .get(`${environment.apiBaseUrl}devices/allDTC`, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                console.log(response);
                // console.log(response.data.data);
                y = response.data.data;
                //return response.data.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getDevicesDTC();
    return y;
};

export const getDeviceByIDAsync = async (requestBody: DeviceByIDBody) => {
    console.log('getDeviceByIDAsync');
    let response: any;
    const getDeviceByID = async () => {
        await axios
            .post(`${environment.apiBaseUrl}devices/byID`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((res) => {
                console.log(res);
                // console.log(response.data.data);
                response = res.data.data;
                //return response.data.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getDeviceByID();
    return response;
};

export const getDeviceByIDAsyncDTC = async (requestBody: DeviceByIDBody) => {
    console.log('getDeviceByIDAsync');
    let response: any;
    const getDeviceByID = async () => {
        await axios
            .post(`${environment.apiBaseUrl}devices/byIDdtc`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((res) => {
                console.log(res);
                // console.log(response.data.data);
                response = res.data.data;
                //return response.data.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getDeviceByID();
    return response;
};

export default getDevicesAsync;
